/* Axiom Supply — Truck Hub (pages/truck-all)
   - Scroll-reveal for [data-th-reveal]
   - "Find Your Truck" jumps to the global <vehicle-search> bar (flash + focus)
   - Smooth in-page anchor scroll for "Shop by Make"
   No deps; degrades gracefully. */
(function () {
  "use strict";

  var HEADER_OFFSET = 90;

  function reveal(root) {
    var nodes = root.querySelectorAll("[data-th-reveal]");
    if (!nodes.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function findSearch() {
    return document.querySelector("vehicle-search:not(.vehicle-search--mobile-only)") ||
      document.querySelector("vehicle-search");
  }

  function jumpToSearch() {
    var vs = findSearch();
    if (!vs) { window.location.href = "/collections/all"; return; }
    var top = vs.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    vs.classList.remove("vehicle-search--flash");
    void vs.offsetWidth; // reflow so the animation can replay
    vs.classList.add("vehicle-search--flash");
    var year = vs.querySelector('[data-vs="year"]');
    if (year) { window.setTimeout(function () { try { year.focus({ preventScroll: true }); } catch (e) { year.focus(); } }, 480); }
  }

  function smoothAnchor(e, root) {
    var id = this.getAttribute("href");
    if (!id || id.charAt(0) !== "#") return;
    var target = root.querySelector(id);
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  function init() {
    var root = document.querySelector("truck-hub");
    if (!root) return;
    reveal(root);

    var findBtn = root.querySelector("[data-th-find]");
    if (findBtn) findBtn.addEventListener("click", jumpToSearch);

    root.querySelectorAll("[data-th-scroll]").forEach(function (a) {
      a.addEventListener("click", function (e) { smoothAnchor.call(a, e, root); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
